<template>
  <div class="header-skeleton">
    <!-- Breadcrumb skeleton -->
    <div class="breadcrumb-skeleton mb-3">
      <div class="skeleton-item skeleton-breadcrumb"></div>
    </div>
    
    <!-- Profile header skeleton -->
    <div class="profile-header-skeleton">
      <div class="row align-items-center">
        <div class="col-auto">
          <div class="skeleton-item skeleton-avatar"></div>
        </div>
        <div class="col">
          <div class="skeleton-item skeleton-title mb-2"></div>
          <div class="skeleton-item skeleton-subtitle mb-1"></div>
          <div class="skeleton-item skeleton-address"></div>
        </div>
        <div class="col-auto">
          <div class="skeleton-item skeleton-button"></div>
        </div>
      </div>
    </div>
    
    <!-- Tabs skeleton -->
    <div class="tabs-skeleton mt-3">
      <div class="d-flex">
        <div v-for="n in 5" :key="n" class="skeleton-item skeleton-tab mr-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderLoadingSkeleton'
};
</script>

<style scoped>
.header-skeleton {
  padding: 20px;
  background: white;
  border-radius: 8px;
  margin-bottom: 20px;
}

.skeleton-item {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-breadcrumb {
  height: 20px;
  width: 300px;
}

.skeleton-avatar {
  height: 80px;
  width: 80px;
  border-radius: 50%;
}

.skeleton-title {
  height: 24px;
  width: 200px;
}

.skeleton-subtitle {
  height: 18px;
  width: 150px;
}

.skeleton-address {
  height: 16px;
  width: 250px;
}

.skeleton-button {
  height: 36px;
  width: 120px;
  border-radius: 6px;
}

.skeleton-tab {
  height: 40px;
  width: 100px;
  border-radius: 6px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HeaderLoadingSkeleton.vue